import React, { Component } from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff';
import authService from 'services/authService';
import UserDetails from './UserDetails';
import Portal from 'root/scenes/StudentPortal/Portal';
import AppContext from 'components/appContext';
import UIComponent from 'components/UiComponent';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '../Tooltip'
import {withTranslation} from "react-i18next";
import config from 'root/../config';
import languageService from 'services/languageService';

class SideBar extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            langTooltipOpen:false
        }

        this._handleCloseLangTooltip = this._handleCloseLangTooltip.bind(this)
        this._handleOpenLangTooltip = this._handleOpenLangTooltip.bind(this)
    }

    _drawerCallBack(status){
        this.context.set('drawerOpen',status);
    }

    _handleCloseLangTooltip(){
        this.setState({
            langTooltipOpen:false
        })
    }
    _handleOpenLangTooltip(){
        this.setState({
            langTooltipOpen:true
        })
    }

    render() {
        const logOut = () => {
            authService.logOut();
        }
        
        const {t} = this.props
        const availableLanguages = languageService.getAvailableLanguages();

        return (
            <React.Fragment>
                <div className="header__menu-container pull-right">
                    <div tabIndex="0" onClick={() => this.context.set('drawerOpen',true)} className="header__btn-menu">
                        <FontAwesomeIcon icon={faBars} size={"1x"} className="mt-2"/>
                    </div>
                    {
                        config.allowMultiLanguage ? 

                        <Tooltip 
                            handleClickAway={this._handleCloseLangTooltip} 
                            open={this.state.langTooltipOpen}
                            languageList={availableLanguages}
                        >
                            <div 
                                tabIndex="0"
                                className="header__lang-switch" 
                                onClick={this._handleOpenLangTooltip}
                            >
                                <FontAwesomeIcon icon={faGlobe} size={"1x"} className="mt-2"/>
                            </div>
                        </Tooltip> 
                        :
                        null
                    }

                </div>

                <SwipeableDrawer 
                    className="side-drawer"                    
                    anchor="right" 
                    open={this.context.drawerOpen} 
                    disableSwipeToOpen={false}
                    onOpen={() => this._drawerCallBack(true)} 
                    onClose={() => this._drawerCallBack(false)}
                    swipeAreaWidth={10}
                    keepMounted={true}
                    ref={el => this.drawer = el}
                >
                    <UserDetails drawer={this.drawer}/>

                    <Portal isSideBar={true}/>

                    <UIComponent 
                        id="logout" 
                        component="smart-button" 
                        class="log-out-btn btn__no-border"
                        iconComponent={<FontAwesomeIcon icon={faPowerOff} size={"1x"} />}
                        onClick={logOut.bind(this)}
                        triggeredText={this.props.t("lbl.LOGGING_OUT","Logging out...")}
                    >
                        {t("lbl.LOG_OUT","Log out")}
                    </UIComponent>
                </SwipeableDrawer>
            </React.Fragment>
        )
    }
}

export default withTranslation()(SideBar);